module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC0SURBVDhPnZMNEoQgCIVlp3vpzaKb6clYH0qbPzVr3wwDqcDDikTE9RDRuNiR8wh+KIBkZnZcn+GHOO8DLYICZlhrFu4sn4sxqt+QdVIru+Movmffh71zBJ27xtMCSAZELnfXMISgcxRVzK3MmeFMlW8jqIKm+xOX7gAKPhrZ7E/c3Ave5avuoCh40d17XyNT8Ad9dwAF0y9xdnjG7xIXgPzrCMsFUkpqxnIBw8Z8/TsDEaEvib2kgJXKg78AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/NOTEPAD_16.png
// module id = 88
// module chunks = 0